// extracted by mini-css-extract-plugin
export default {"block":"InfoCard_block__eB-ry","content":"InfoCard_content__XKxUv","bigTitle":"InfoCard_bigTitle__VpFgR","text":"InfoCard_text__naOoq"};